import { render } from "./TeasersSlider.vue?vue&type=template&id=77637ce9&ts=true"
import script from "./TeasersSlider.vue?vue&type=script&lang=ts"
export * from "./TeasersSlider.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/janvodila/Sites/semperit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__